import React, { useState } from "react";
import { usePublicBillingCatalog } from "@/hooks/usePublicBillingCatalog";
import { fromPriceLine } from "@/lib/landingCatalogCopy";
import QuietNavbar from "./shared/QuietNavbar.jsx";
import QuietFooter from "./shared/QuietFooter.jsx";
import QuietHero from "./sections/QuietHero.jsx";
import QuietChannelsSection from "./sections/QuietChannelsSection.jsx";
import { CaseStudySection } from "./caseStudy";
import { LiveProofSection } from "./liveProof";
import QuietInterceptSection from "./sections/QuietInterceptSection.jsx";
import QuietClosingCta from "./sections/QuietClosingCta.jsx";
import LeadCaptureModal from "./modal/LeadCaptureModal.jsx";

const MainLanding = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const { status: catalogStatus, entryOffer } = usePublicBillingCatalog();
  const entryLine = entryOffer
    ? fromPriceLine(entryOffer.amount_minor, entryOffer.currency)
    : null;

  const openLeadModal = () => setIsLeadModalOpen(true);
  const closeLeadModal = () => setIsLeadModalOpen(false);

  return (
    <div className="quiet-landing min-h-screen" data-testid="quiet-landing">
      <QuietNavbar onSignUp={openLeadModal} />
      <div className="h-14 md:h-16" aria-hidden="true" />
      <div className="cursor-grid-shell">
        <main>
          <QuietHero onOpenModal={openLeadModal} />
          <QuietChannelsSection />
          <QuietInterceptSection />
          <LiveProofSection />
          <CaseStudySection />
          <QuietClosingCta onOpenModal={openLeadModal} entryLine={entryLine} catalogStatus={catalogStatus} />
        </main>
        <QuietFooter />
      </div>
      <LeadCaptureModal isOpen={isLeadModalOpen} onClose={closeLeadModal} entryLine={entryLine} catalogStatus={catalogStatus} />
    </div>
  );
};

export default MainLanding;
